import { MAX_CUSTOM_RANGE_DAYS } from '@sportspredict/shared';
import type { LeaderboardDateType } from './leaderboard-type-filter';

export const DAY_MS = 24 * 60 * 60 * 1000;

export const LEADERBOARD_DATE_RANGE_VALIDATION_MESSAGES = {
	incomplete: 'Select both a start and end date.',
	invalid: 'Enter a valid start and end date.',
	reversed: 'The end date must be on or after the start date.',
	future: "Future dates aren't allowed. Select a date up to today.",
	exceedsMaximum: `Date range cannot exceed ${MAX_CUSTOM_RANGE_DAYS} days.`,
} as const;

export const DATE_LABELS: Record<LeaderboardDateType, string> = {
	global: 'Global',
	knockout: 'Knockout Stage',
	finals: 'Finals',
};
